module.exports = __webpack_public_path__ + "static/media/pig_bank-512.47bc9623.png";